@import '../../styles/colors.css';

#chipsContainer {
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 50em;
}

#contentContainer {
  display: flex;
  justify-content: center;
  background-color: var(--white);
  padding-bottom: 5em;
}

#formContainer {
  display: flex;
  flex-direction: column;
  gap: 2em;
}

#header {
  margin-bottom: 3em;
  width: 100%;
}

#menu {
  list-style-type: none;
  display: flex;
  gap: 3em;
  margin: 0;
  padding: 0;
}

#pageContainer {
  width: 100%;
  background-color: var(--white);
}

.backButton {
  color: var(--darkPurple);
  cursor: pointer;
  width: 10em;
  height: 3.5em;
  background-color: var(--white);
  border-radius: 3px;
  border: none;
  text-transform: uppercase;
}

.backButton:hover {
  background-color: var(--blue);
  color: #fff;
}

.button {
  color: var(--white);
  cursor: pointer;
  width: inherit;
  height: 3.5em;
  background-color: var(--green);
  border-radius: 3px;
  border: none;
  text-transform: uppercase;
}

.buttonContainer {
  display: flex;
  width: 25em;
  gap: 1em;
}

.disabledMenuItem {
  color: var(--white);
  text-transform: uppercase;
  padding-bottom: 0.5em;
  cursor: default;
}

.flexColumnCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flexRowCenter {
  display: flex;
  justify-content: center;
}

.formSection {
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 25em;
}

.formSectionLabel {
  font-size: 11pt;
}

.menuItem {
  color: var(--darkPurple);
  text-transform: uppercase;
  padding-bottom: 0.5em;
  cursor: pointer;
}

.selectedMenuItem {
  font-weight: bolder;
  border-bottom: 3px solid var(--green);
}
